import React from 'react';
import {useTranslation} from 'react-i18next';
import {editSidebarElementTranslationKey, editSidebarGroupTranslationKey, elementGroups} from '../../constants/elementGroups';
import AccordionItem from './AccordionItem';
import ElementBox from './ElementBox';
import {useAddElementAction} from '../../context/AddElementsContext';

function EditPresSidebar(): JSX.Element {
    const {t} = useTranslation();
    const addElement = useAddElementAction();

    return (
        <div className="p-presEdit__sidebar_body">
            {elementGroups.map((group, index) => (
                <AccordionItem key={`element-group-${index}`} open header={t(editSidebarGroupTranslationKey(group.label))}>
                    <div className="l-gridNative">
                        {group.items.map((element, elementIndex) => (
                            <div key={`element-group-${index}-${elementIndex}`} className="l-colNative:4">
                                <ElementBox
                                    onMouseUp={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        addElement(element.type, element.elementProps);
                                    }}
                                    icon={element.icon}
                                    type={element.type}
                                    element={t(editSidebarElementTranslationKey(element.label))}
                                />
                            </div>
                        ))}
                    </div>
                </AccordionItem>
            ))}
        </div>
    );
}

export default EditPresSidebar;
